import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DoNotDisturbOnSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DoNotDisturbOnSVG;
